import { createRef } from "react";
import "./SignupAuth.scss";
import { resolutionPropType, signupPageAuthShape } from "app/utils/propTypes";
import SignupMarketing from "app/pages/SignupPage/Auth/SignupMarketing/SignupMarketing";
import ReasonToBookBlockContainer from "app/pages/.shared/ReasonsToBook/ReasonToBookBlock/ReasonToBookBlockContainer";
import ProductListBlockContainer from "app/pages/.shared/DynamicBlocks/blocks/ProductListBlock/ProductListBlockContainer";
import HeaderContainer from "app/pages/Header/HeaderContainer";

const SignupAuth = ({ signupPageAuth = {}, resolution }) => {
	const productListHeaderRef = createRef();

	return (
		<div className="signup-auth" data-testid="signup-auth">
			<HeaderContainer showMenuItems={false} />

			<SignupMarketing
				resolution={resolution}
				productListHeaderRef={productListHeaderRef}
				signupPage={signupPageAuth}
			/>

			<section className="signup-auth__products" ref={productListHeaderRef}>
				<ProductListBlockContainer
					shortVersion
					merchCode={signupPageAuth?.featuredMerchCode}
					shortVersionFeaturedProductUris={signupPageAuth?.productsUri}
				/>
			</section>

			<div className="signup-auth__rtb">
				<ReasonToBookBlockContainer />
			</div>
		</div>
	);
};

SignupAuth.propTypes = {
	resolution: resolutionPropType,
	signupPageAuth: signupPageAuthShape,
};

export default SignupAuth;
